
// import Footer from '@/components/footer/index';
export default {
  components: {
    // Footer
  }
}
